const isCookieBotEnabled = (process.env.NEXT_PUBLIC_COOKIEBOT_ENABLED ?? "true") === "true";
export default isCookieBotEnabled;